import React, { useMemo } from "react";
import { Alert, List, Modal, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { planWeightSplit } from "functions/pickRoute";

const { Text } = Typography;

/**
 * "Vakken per gewicht maken" (besluit 2: elk gewicht een eigen vak en barcode). Previews the plan
 * the hook will write, computed by the same pure function, so what is shown is what happens.
 */
const WeightSplitModal = ({ open, entries, catalogue, onCancel, onConfirm, busy }) => {
  const { t } = useTranslation();
  const plan = useMemo(() => (open ? planWeightSplit(entries, catalogue) : null), [open, entries, catalogue]);
  const nothingToDo = !!plan && plan.creates.length === 0 && plan.updates.length === 0;
  const newLabels = plan ? plan.creates.map((create) => create.data.label) : [];

  return (
    <Modal
      open={open}
      title={t("pick_route.split_title")}
      okText={t("pick_route.split_apply")}
      cancelText={t("cancel")}
      okButtonProps={{ disabled: !plan || nothingToDo, loading: busy }}
      onOk={onConfirm}
      onCancel={onCancel}
      width={560}
    >
      <p style={{ color: "#6b6b6b" }}>{t("pick_route.split_help")}</p>
      {!!plan && nothingToDo && <Alert type="success" showIcon message={t("pick_route.split_nothing")} />}
      {!!plan && !nothingToDo && (
        <>
          <Alert
            type="info"
            showIcon
            className="mb-3"
            message={t("pick_route.split_summary", {
              entries: plan.summary.splitEntries,
              created: plan.summary.createdEntries,
              articles: plan.summary.placedArticles,
            })}
            description={t("pick_route.split_codes_note")}
          />
          {newLabels.length > 0 && (
            <List
              size="small"
              header={<Text strong>{t("pick_route.split_new_vakken")}</Text>}
              dataSource={newLabels.slice(0, 15)}
              renderItem={(label) => <List.Item>{label}</List.Item>}
              footer={newLabels.length > 15 ? <Text type="secondary">{t("pick_route.and_more", { count: newLabels.length - 15 })}</Text> : null}
            />
          )}
        </>
      )}
    </Modal>
  );
};

export default WeightSplitModal;
